import { env } from '@/env'
import { api } from '@/services/fintalk/api'

export interface Project {
  _id: string
  company_id: string
  name: string
  picture: string
  active: boolean
  created_at: Date
  updated_at: Date
  bots: string[]
}

export async function listProjects(companyId: string): Promise<Project[]> {
  const resp = await api.get<Project[]>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    `/company/${companyId}/projects`,
  )

  return resp.body
}
